const Automation = () => import("@/modules/automation/pages/Automation.vue");

export default [
  {
    path: "/settings/automation",
    name: "automation",
    component: Automation,
    meta: {
      authRequired: true,
      allowDevelopers: true,
    },
  },
];
